import { WcgChipType } from '@wcg/frontend-framework';

export function getStatusType(status: string): WcgChipType {
  switch (status?.toLowerCase()) {
    case 'approved':
    case 'active':
    case 'completed':
    case 'published':
    case 'enabled':
    case 'complete':
      return WcgChipType.SUCCESS;
    case 'pending':
    case 'pre-review':
    case 'review':
    case 'access_requested':
    case 'withwcg':
    case 'with_wcg':
      // ERM-13744: client resubmitted, submission back in WCG's hands (informational).
      return WcgChipType.INFO;
    case 'onhold':
    case 'on_hold':
    case 'suspended':
    case 'invited':
    case 'access requested':
      return WcgChipType.WARNING;
    case 'disapproved':
    case 'closed':
    case 'todo':
      return WcgChipType.CRITICAL;
    case 'inactive':
    case 'draft':
    default:
      return WcgChipType.NEUTRAL;
  }
}
